import React, { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';
import { X, Gift } from 'lucide-react';

const NotificationBanner = () => {
  const { notifications, markNotificationsRead } = useApp();
  const [visible, setVisible] = useState(false);
  const [currentNotification, setCurrentNotification] = useState(null);

  useEffect(() => {
    if (notifications && notifications.length > 0) {
      setCurrentNotification(notifications[0]);
      setVisible(true);
    }
  }, [notifications]);

  const handleDismiss = () => {
    setVisible(false);
    if (notifications.length > 0) {
      markNotificationsRead(notifications.map(n => n.id));
    }
  };

  if (!visible || !currentNotification) return null;

  return (
    <div
      className="fixed top-20 left-1/2 -translate-x-1/2 z-[100] w-full max-w-md px-4 animate-slide-down"
      data-testid="notification-banner"
    >
      <div className="bg-white dark:bg-neutral-900 rounded-2xl shadow-2xl border border-emerald-100 p-4 flex items-start gap-3">
        <div className="w-10 h-10 bg-emerald-100 dark:bg-emerald-500/15 rounded-full flex items-center justify-center flex-shrink-0">
          <Gift className="w-5 h-5 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-bold text-gray-900 dark:text-neutral-100 text-sm">{currentNotification.title}</p>
          <p className="text-gray-600 dark:text-neutral-400 text-xs mt-0.5 leading-relaxed">{currentNotification.message}</p>
          {notifications.length > 1 && (
            <p className="text-emerald-600 dark:text-emerald-400 text-xs mt-1 font-medium">+{notifications.length - 1} more notification{notifications.length > 2 ? 's' : ''}</p>
          )}
        </div>
        <button
          onClick={handleDismiss}
          className="text-gray-400 dark:text-neutral-500 hover:text-gray-600 p-1 flex-shrink-0"
          data-testid="dismiss-notification"
        >
          <X size={16} />
        </button>
      </div>
      <style>{`
        @keyframes slideDown {
          from { transform: translate(-50%, -20px); opacity: 0; }
          to { transform: translate(-50%, 0); opacity: 1; }
        }
        .animate-slide-down {
          animation: slideDown 0.4s ease-out;
        }
      `}</style>
    </div>
  );
};

export default NotificationBanner;
